import { render, staticRenderFns } from "./RedBagCont.vue?vue&type=template&id=057d8cc1&scoped=true"
import script from "./RedBagCont.vue?vue&type=script&lang=js"
export * from "./RedBagCont.vue?vue&type=script&lang=js"
import style0 from "./RedBagCont.vue?vue&type=style&index=0&id=057d8cc1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057d8cc1",
  null
  
)

export default component.exports